import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a7f1511"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "condition-group__actions"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-trash" }, null, -1));
const _hoisted_4 = {
    key: 0,
    class: "condition-group__list"
};
const _hoisted_5 = { class: "icon icon-plus" };
const _hoisted_6 = {
    class: "more-top",
    "aria-hidden": "true"
};
const _hoisted_7 = { class: "text" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "more-bottom",
    "aria-hidden": "true"
}, null, -1));
import { computed, provide } from 'vue';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import AudienceConditionForm from '@/features/AudienceManager/components/Stages/Composition/AudienceConditionForm.vue';
import AudienceConditionRow from '@/features/AudienceManager/components/Stages/Composition/AudienceConditionRow.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceConditionCardGroup',
    props: {
        groupConditions: {},
        isInclude: { type: Boolean },
        groupIndex: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { isCreationMode, groupType, conditionsByGroupType } = useAudienceManager(props.isInclude, props.groupIndex);
        provide('groupIndex', props.groupIndex);
        provide('isInclude', props.isInclude);
        provide('groupType', groupType.value);
        const hasConditions = computed(() => props.groupConditions.length > 0);
        const activeGroupIndex = computed(() => store.getters['audienceManager/activeGroupIndex']);
        const isFormVisible = computed(() => store.getters['audienceManager/isConditionFormVisible']);
        const shouldShowConditionForm = computed(() => {
            const isThisGroupActive = activeGroupIndex.value === props.groupIndex;
            return (isFormVisible.value && isThisGroupActive) || !hasConditions.value;
        });
        const shouldShowDeleteGroupButton = computed(() => !props.isInclude || (props.isInclude && conditionsByGroupType.value.length > 1));
        const showButtonAddCondition = computed(() => hasConditions.value && isCreationMode.value && !shouldShowConditionForm.value);
        const addNewCondition = () => {
            resetSelectedCriteria();
            setEditingCondition({
                column: '',
                operator: '',
                value: [],
                referenceObjects: {},
                f_operator: '',
                f_value: [],
                f_type: '',
            }, false);
        };
        const resetSelectedCriteria = () => {
            store.dispatch('audienceManager/updateSelectedCriteria', {
                criteriaKey: null,
                groupType: groupType.value,
                groupIndex: props.groupIndex,
            });
        };
        const setEditingCondition = (draftCondition, isEditing) => {
            store.dispatch('audienceManager/setEditingCondition', {
                groupType: groupType.value,
                groupIndex: props.groupIndex,
                draftCondition,
            });
            store.dispatch('audienceManager/setConditionEditMode', isEditing);
            toggleConditionForm(true);
        };
        const toggleConditionForm = (isVisible) => {
            store.dispatch('audienceManager/toggleConditionForm', { isVisible, groupIndex: props.groupIndex });
        };
        const removeGroup = () => {
            store.dispatch('audienceManager/removeGroup', {
                isInclude: props.isInclude,
                groupIndex: props.groupIndex,
            });
        };
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("section", {
                class: _normalizeClass(["condition-group", _unref(groupType)])
            }, [
                (_unref(isCreationMode))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (shouldShowDeleteGroupButton.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _withModifiers(removeGroup, ["prevent"]),
                                class: "condition-group__actions__btn-delete-group"
                            }, [
                                _hoisted_3,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('audiences.delete-group')), 1)
                            ], 8, _hoisted_2))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["condition-group__form", { 'column-layout': !showButtonAddCondition.value }])
                }, [
                    _withDirectives(_createVNode(AudienceConditionForm, null, null, 512), [
                        [_vShow, shouldShowConditionForm.value && _unref(isCreationMode)]
                    ]),
                    (hasConditions.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.groupConditions, (condition, rowIndex) => {
                                return (_openBlock(), _createBlock(AudienceConditionRow, {
                                    key: rowIndex,
                                    "row-id": rowIndex,
                                    condition: condition
                                }, null, 8, ["row-id", "condition"]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (showButtonAddCondition.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: addNewCondition,
                            class: "btn condition-group__form__add-condition"
                        }, [
                            _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
                                [_directive_tooltip, { content: _ctx.$t('audiences.add-condition'), distance: 8 }]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('or')), 1)
                ]),
                _hoisted_8
            ], 2));
        };
    }
});
